import { render, staticRenderFns } from "./ExtraProductsItem.vue?vue&type=template&id=e3420e9a&"
import script from "./ExtraProductsItem.vue?vue&type=script&lang=js&"
export * from "./ExtraProductsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports